import { useDispatch } from 'react-redux';
import { addMessage } from '../state/actions/messagesActions';
import ownershipHelpers from '../helpers/ownershipHelpers';
import { isCreditBasedLegacy } from '../helpers/subscriptionHelpers';
import { CollectionOwnershipResponse } from '../types/api/OwnershipTypes';
import { User } from '../types/api/UsersTypes';
import { SubscriptionDetail } from '../types/api/SubscriptionTypes';

export const usePricingLogic = ({
  item,
  onPurchased,
  onOwnershipDataLoaded,
  user,
  subscription
}: {
  item: any;
  onPurchased?: () => void;
  onOwnershipDataLoaded?: (ownership: any) => void;
  user: User;
  subscription?: SubscriptionDetail;
}) => {
  const dispatch = useDispatch();
  const { getOwnershipFor } = ownershipHelpers;

  const handlePurchase = async () => {
    if (onPurchased) onPurchased();
    if (!onOwnershipDataLoaded) return;

    try {
      const ownershipResponse = await getOwnershipFor(user, item);
      onOwnershipDataLoaded((ownershipResponse as CollectionOwnershipResponse).data);
    } catch (e) {
      dispatch(
        addMessage({
          type: 'error',
          body: e.message
        })
      );
    }
  };

  const isPricingVisible = () => {
    return item.membership_tier !== 'silver' && !item.free_product && !subscription;
  };

  const isLegacyCredit = isCreditBasedLegacy(subscription);
  const isSilverTier = item.membership_tier === 'silver';
  const isFreeProduct = item.free_product;

  return {
    handlePurchase,
    isPricingVisible,
    isLegacyCredit,
    isSilverTier,
    isFreeProduct
  };
};
